module.exports = __webpack_public_path__ + "9cb6ade5f1a35448b9890ed036f854d2.png";